import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { format } from 'date-fns';
import { IAccountDynamicsFilter } from '@pages/AccountsDynamics/List/filter';
import { IAccountDynamicsLine } from '@entities/accountDynamics/IAccountDynamicsLine';

export const fetchData = async (
  filters: IAccountDynamicsFilter
): Promise<IAccountDynamicsLine[]> => {
  let data = {};

  if (filters.search?.length) {
    data = { ...data, q: filters.search };
  }

  if (filters.dateFrom) {
    data = {
      ...data,
      date_from: format(new Date(filters.dateFrom), 'yyyy-MM-dd'),
    };
  }

  if (filters.dateTo) {
    data = {
      ...data,
      date_to: format(new Date(filters.dateTo), 'yyyy-MM-dd'),
    };
  }

  const response = await api.get<IAccountDynamicsLine[]>(`${BI_BASE_URL}/dynamic/line`, {
    params: {
      managers_ids: filters.managers,
      region: filters.regions,
      source: filters.sources,
      tags: filters.tags,
      accounts: filters.accounts,
      account_type: filters.accountType,
      activities: filters.activity,
      account_statuses: filters.created_at,
      by_type: filters.byType,
      ...data,
    },
  });

  return response.data ?? [];
};

export const useAccountDynamicsLine = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
